import { CILabel } from 'ccs-ui-components';
import { Col, Form, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { IQueryPathParam, IServiceDetailsValidationModel } from '../../../../../../models';
import AuthMethod from '../../auth-method/AuthMethod';
import AuthUrl from '../../auth-url/AuthUrl';
import InputHandler from '../../param-handler/InputHandler';
import ItemHandler from '../../param-list-handler/ItemHandler';
import classes from './AuthParamFields.module.scss';

interface IAuthParamFieldsProps {
  isEdit: boolean;
  formData: IServiceDetailsValidationModel;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  authMethodChangeHandler: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  authMethodValue: string | undefined;
  headerParamListHandler: (data: IQueryPathParam[]) => void;
  headerParamList: IQueryPathParam[];
  requestParamListHandler: (data: IQueryPathParam[]) => void;
  requestParamList: IQueryPathParam[];
  queryPathParamListHandler: (data: IQueryPathParam[]) => void;
  queryPathParamList: IQueryPathParam[];
  serviceTypeValue: string | undefined
}
const AuthParamFields = ({
  isEdit,
  formData,
  handleInputChange,
  authMethodChangeHandler,
  authMethodValue,
  headerParamListHandler,
  headerParamList,
  requestParamListHandler,
  requestParamList,
  queryPathParamListHandler,
  queryPathParamList,
  serviceTypeValue
}: IAuthParamFieldsProps) => {
  const { t: translate } = useTranslation();
  return (
    <Row>
      <AuthMethod authMethodChangeHandler={authMethodChangeHandler} authMethodValue={authMethodValue} />
      <AuthUrl isEdit={isEdit} formData={formData} serviceTypeValue={serviceTypeValue} handleInputChange={handleInputChange} />
      <Form.Group className="py-2">
        <CILabel id="headerParamKey" labelText={translate('service_operation_form.service_header_param')} />
        {isEdit ? (
          <InputHandler
            listOfItems={headerParamListHandler}
            paramName="Header Param"
            list={headerParamList}
          />
        ) : (
          <Row className={classes['param-container']}>
            <Row className={classes['param-header']}>
              <Col sm={5}>{translate('service_operation_form.param_key')}</Col>
              <Col sm={6} className={classes['value-header']}>
                {translate('service_operation_form.param_value')}
              </Col>
            </Row>
            {(!headerParamList
              || headerParamList?.length < 1) && (
                <div className={classes['no-data']}>
                  {translate('service_details_form_component.plchd_no_records', {
                    replace: { param: 'Header Param' }
                  })}
                </div>
              )}
            {headerParamList?.map((item, index) => (
              <ItemHandler
                key={item.key}
                index={index}
                itemKey={item.key}
                itemValue={item.value}
                isEdit={item.isEdit}
                isView
              />
            ))}
          </Row>
        )}
      </Form.Group>
      <Form.Group className="py-2">
        <CILabel id="requestParam" labelText={translate('service_details_form_component.lbl_request_param')} />
        {isEdit ? (
          <InputHandler
            listOfItems={requestParamListHandler}
            list={requestParamList}
            paramName="Request Param"
          />
        ) : (
          <Row className={classes['param-container']}>
            <Row className={classes['param-header']}>
              <Col sm={5}>{translate('service_operation_form.param_key')}</Col>
              <Col sm={6} className={classes['value-header']}>
                {translate('service_operation_form.param_value')}
              </Col>
            </Row>
            {(!requestParamList
              || requestParamList?.length < 1) && (
                <div className={classes['no-data']}>
                  {translate('service_details_form_component.plchd_no_records', {
                    replace: { param: 'Request Param' }
                  })}
                </div>
              )}
            {requestParamList?.map((item, index) => (
              <ItemHandler
                key={item.key}
                index={index}
                itemKey={item.key}
                itemValue={item.value}
                isEdit={item.isEdit}
                isView
              />
            ))}
          </Row>
        )}
      </Form.Group>
      <Form.Group className="py-3">
        <CILabel id="queryParamKey" labelText={translate('service_details_form_component.service_query_path_param')} />
        {isEdit ? (
          <InputHandler
            listOfItems={queryPathParamListHandler}
            list={queryPathParamList}
            paramName="QueryPath Param"
          />
        ) : (
          <Row className={classes['param-container']}>
            <Row className={classes['param-header']}>
              <Col sm={5}>{translate('service_operation_form.param_key')}</Col>
              <Col sm={6} className={classes['value-header']}>
                {translate('service_operation_form.param_value')}
              </Col>
            </Row>
            {(!queryPathParamList
              || queryPathParamList?.length < 1) && (
                <div className={classes['no-data']}>
                  {translate('service_details_form_component.plchd_no_records', {
                    replace: { param: 'QueryPath Param' }
                  })}
                </div>
              )}
            {queryPathParamList?.map((item, index) => (
              <ItemHandler
                key={item.key}
                index={index}
                itemKey={item.key}
                itemValue={item.value}
                isEdit={item.isEdit}
                isView
              />
            ))}
          </Row>
        )}
      </Form.Group>
    </Row>
  );
};

export default AuthParamFields;
